import {
    useEffect,
    useState,
} from 'react';
import {
    Container
} from './styled';
import { useAuth } from '../../contexts/auth';
import { useHistory } from 'react-router-dom';
import security from '../../assets/SVGs/security.svg';
import {
    ResetPassword
} from '../../components';

export function FirstAccess() {

    const history = useHistory();
    const { user } = useAuth();
    const [renderResetPassword, setRenderResetPassword] = useState(false);


    const redirect = () => {
        history.push('/');
    }
    useEffect(() => {
        if (!user) {
            redirect();
        }
    }, [user])

    if (!user) {
        return (<></>)
    }
    return (
        <Container>
            {(!renderResetPassword)
                ? (<div>
                    <div>
                        <p>
                            {`Olá ${(user?.nomecompleto)?.split(" ")[0]} !`}
                        </p>
                        <p>
                            {`Parece que esta é sua primeira vez aqui. 
                                        Para garantir a segurança da sua conta,
                                        vamos precisar redefinir sua senha.
                                    `}
                        </p>
                    </div>
                    <div className='acMt'>
                        <button
                            className='op2'
                            onClick={() => { redirect() }}
                        >
                            {`Cancelar`}
                        </button>
                        <button
                            className='op1'
                            onClick={() => { setRenderResetPassword(true) }}

                        >
                            {`Prosseguir`}
                        </button>
                    </div>
                    <img
                        className="security"
                        src={security}
                        alt=""
                    />
                </div>)
                : (
                    <ResetPassword
                        onBack={() => {
                            setRenderResetPassword(false)
                        }}
                    />
                )
            }
        </Container>
    );
}